import { useFitFinishFrameSections } from '../../../hooks/exterior/useFitFinishFrameSections';
import { useLevel2ExteriorSections } from '../../../hooks/exterior/useLevel2ExteriorSections';
import { useTireSections } from '../../../hooks/exterior/useTireSections';
import { GradeUIBar } from './GradeUIBar';
import { useParsedGrades } from './useParsedGrades';

export const ExteriorGrades = () => {
  const exteriorSections = useLevel2ExteriorSections();
  const tireSections = useTireSections();
  const fitFinishFrameSections = useFitFinishFrameSections();

  const grades = useParsedGrades([...exteriorSections, ...tireSections, ...fitFinishFrameSections]);
  return <GradeUIBar gradePercents={grades} />;
};
